module.exports = __webpack_public_path__ + "static/media/note_pad.fb0cac8b.png";